import { c as _c } from "react/compiler-runtime";
import { useBetaFeatures } from '@/lib/hooks/api/settings-hooks';
import { DEFAULT_BETA_FEATURES, normalizeBetaFeatures } from '@/types/beta-features';
export function useWebsiteHoverPreviewFeature(userId) {
  const $ = _c(4);
  const hasUser = typeof userId === "string" && userId.length > 0;
  let t0;
  if ($[0] !== hasUser) {
    t0 = {
      enabled: hasUser
    };
    $[0] = hasUser;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: betaFeatures
  } = useBetaFeatures(t0);
  const fallback = DEFAULT_BETA_FEATURES.websiteHoverPreview ?? false;
  if (!hasUser) {
    return fallback;
  }
  let t1;
  if ($[2] !== betaFeatures) {
    t1 = normalizeBetaFeatures(betaFeatures);
    $[2] = betaFeatures;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const resolvedFeatures = t1;
  return resolvedFeatures.websiteHoverPreview ?? fallback;
}